import {useState} from 'react';
import update from 'immutability-helper';

const useSarasColumnDnDManager = (dndType, defaultSortMode) => {
    const [sortMode, setSortMode] = useState(defaultSortMode === undefined ? true : defaultSortMode);

    const onToggleSort = () => {
        setSortMode(!sortMode);
    }

    const isSortMode = () => {
        return sortMode;
    }

    const groupKeys = (groupData) => {
        return groupData ? groupData.ViewRowsKeys : [];
    }

    const getGroupRow = (groupRow, rowIndex) => {
        return {};
    }

    const getGroupRowsKeys = (groupRow) => {
        return [];
    }

    const onDragEnd = (viewData, rowKeys, result) => {
        if(!result || !result.source || !result.destination) return null;

        //move the row in local
        let sourceKey = rowKeys[result.source.index];

        //it means moving within the same group
        let newRowKeys = update(rowKeys, {
            $splice: [
                [result.source.index, 1],
                [result.destination.index, 0, sourceKey],
            ],
        });

        //assign the new sortKey to the newRowKeys as per the revised arrangement after manual drag drop
        for(let i=0; i<newRowKeys.length; i++)
        {
            newRowKeys[i].sortKey = i + 1;
        }

        let dropResult = {rowKeys: newRowKeys};

        return dropResult;
    }

    //use toggle sort and is sort mode for image sorting, 
    //because dnd doesn't support sorting of the grid layout, 
    //this toggle will be used by image component to switch to list mode while sorting 
    //and once sorting is done it will switch back to grid layout
    const returnObj = {
        onToggleSort,
        isSortMode,
        onDragEnd,
        groupKeys,
        getGroupRowsKeys,
        getGroupRow,
        dndType
    }

    return returnObj;

}

export default useSarasColumnDnDManager